import { Component, EventEmitter, inject, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GraphqlService } from '../../../../services/graphql.service';
import { NotificationService } from '../../../../services/notification.service';
import { AppState } from '../../../../store';
import { StoreItemActions } from '../../../../store/entities/store-item/store-item.actions';
import { StoreItemEntity } from '../../../../store/entities/store-item/store-item.model';
import { selectStoreItems } from '../../../../store/entities/store-item/store-item.selectors';
import { SystemUserRole } from '../../../../store/entities/system-configurations/temp-fcrs/system-user-role/system-user-role.model';
import { GET_SYSTEM_PERMISSIONS_QUERY, UPDATE_USER_ROLES_MUTATION, CREATE_USER_ROLES_MUTATION } from '../../../../store/entities/user-management/user-role/user-role.graphql';
import { SystemRolesAddComponent } from '../../../user-management/system-roles-list/system-roles-add/system-roles-add.component';
import { CREATE_FAQ_MUTATION, UPDATE_FAQ_MUTATION } from '../../../../store/entities/settings/faq/faq.graphql';
import { DynamicFormService } from '../../../../shared/components/dynamic-forms-components/dynamic-form.service';
import { FieldConfig } from '../../../../shared/components/dynamic-forms-components/field.interface';
import * as fromConfig from './faq-form'
import {Region} from "../../../../store/entities/settings/administrative-area/region/region.model";

@Component({
  selector: 'app-faq-add',
  templateUrl: './faq-add.component.html',
  styleUrl: './faq-add.component.scss'
})
export class FaqAddComponent implements OnInit {


  @Output()
  onClose = new EventEmitter<any>()
  form: UntypedFormGroup;
  saveLoading: boolean;
  private dynamicFormService: DynamicFormService = inject(DynamicFormService)
  faqFields:FieldConfig[]=fromConfig.faqFields

  title: string
  supportForm: UntypedFormGroup;
  loading: boolean = false;


  constructor(
    private store: Store<AppState>,
    private dialogRef: MatDialogRef<SystemRolesAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
  ) {
  }

  ngOnInit(): void {
    this.title = `${ this.data?.id ? 'Edit' : 'Add' } Faq`;
    this.supportForm = this.dynamicFormService.createControl(this.faqFields, null);
    if (this.data?.id) {
      this.supportForm?.patchValue({
        ...this.data,
        regions: this.data?.regions?.map((region: Region) => {
          return region?.uniqueId
        })
      })
    }
  }



  async submitForm(formValue) {

    const input = {
      ...formValue,
      uniqueId:this.data?.uniqueId
    };

    this.store.dispatch(StoreItemActions.createUpdateStoreItem({
      entity: StoreItemEntity.faqs,
      input,
      mutation: this.data?.id ? UPDATE_FAQ_MUTATION : CREATE_FAQ_MUTATION,
      isInput: true
    }))
  }


  closeModal() {
    this.dialogRef.close()
  }

}



